import { Card, Stack, Typography } from '@mui/material';
import hourglass from '../../../../images/hourglass-1.png';

export const NotReady = () => {
  return (
    <Card sx={{ padding: '1rem', width: '100%' }}>
      <Stack direction="column" gap="1rem">
        <Typography variant="h5">Sales Summary</Typography>
        <Stack gap="1rem" direction="column" alignItems="center">
          <img src={hourglass} alt="hourglass" width={86} height={120} />
          <Typography fontWeight="bold" variant="h4">
            Sales Attribution Not Available Yet
          </Typography>
          <Typography>
            Sales Attribution will be available soon, please check back later.
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
};
